import React, { useState } from 'react';
import { useTextSelection } from '../hooks/useTextSelection';
import { TextSelectionButton } from './TextSelectionButton';
import { DocumentSelector } from './DocumentSelector';
import { DocumentApiConfig } from '../types/document';

interface DocumentWrapperProps {
  children: React.ReactNode;
  store: any;
}

export const DocumentWrapper: React.FC<DocumentWrapperProps> = ({ 
  children, 
  store 
}) => {
  const [showDocumentSelector, setShowDocumentSelector] = useState(false);
  const { selection, clearSelection, protectSelection, unprotectSelection } = useTextSelection();

  const handleAddToDocument = () => {
    if (selection) {
      // 保护当前选择，防止被编辑器操作干扰
      protectSelection(selection);
      setShowDocumentSelector(true);
    }
  };

  const handleDocumentSelectorClose = () => {
    setShowDocumentSelector(false);
    unprotectSelection();
    clearSelection();
  };

  const handleDocumentSave = () => {
    setShowDocumentSelector(false);
    unprotectSelection();
    clearSelection();
    // 显示成功提示
    store.notify('success', '文档保存成功');
  };

  // 构建简化的API配置
  const apiConfig: DocumentApiConfig = {
    apiUrl: store.directusApi.url,
    accessToken: store.directusApi.token
  };

  return (
    <>
      {children}
      
      {selection && (
        <TextSelectionButton
          selection={selection}
          onAddToDocument={handleAddToDocument}
        />
      )}
      
      <DocumentSelector
        visible={showDocumentSelector}
        selectedText={selection?.text || ''}
        onCancel={handleDocumentSelectorClose}
        onConfirm={handleDocumentSave}
        apiConfig={apiConfig}
      />
    </>
  );
};